import { ComponentProps } from "react";
import { CloseButton as ToastifyCloseButton } from "react-toastify";

import { Icon } from "../icon";

export const CloseButton = (
  props: ComponentProps<typeof ToastifyCloseButton>
) => {
  return (
    <Icon
      className="text-basketBallOrange absolute top-2.5 right-2.5 size-3 cursor-pointer"
      name="cross"
      onClick={props.closeToast}
    />
  );
};
